<script setup>
import {
    defineProps,
    nextTick,
    // defineEmits,
    onMounted,
    ref,
    watch,
    //  computed
} from 'vue';
import i18n from "@/i18n"
import { showMessage } from "@/utils/hooks/message"
// const emits = defineEmits(['search',])
import usetablePageNation from "@/utils/hooks/usetablePageNation" //分页hooks
import { getDashboardPerformance_comparison } from "@/service/apiList/dashboard"
import { dashbordChart1 } from "@/utils/chart"
import { getProductTemplatePt } from "@/service/"
import PreviewImg from "@/components/common/PreviewImg";
import { getLangValue, makeQrCode } from "@/utils/common"; //获取后端语言
const activeImageSrc = ref('')
const showPreviewImg = ref(false)
const props = defineProps({
    // hscodeList: {
    //     type: Array,
    //     required: true,
    //     default: () => []
    // },
    databaseList: {
        type: Array,
        required: true,
        default: () => []
    },
})
const chartRef = ref(null)
const tableInfo = ref([])
const hscodeList = ref([])
const type = ref("")
const table_head = ref([
    { name: 'NO.', width: '2%', },
    { name: 'HS Code', width: '10%', },
    { name: getLangValue('product-management', "code_pid_gtin"), width: '10%' },
    { name: getLangValue('product-template', "productName"), width: '10%', type: 'name', sortable: true, sortField: 'name' },
    { name: getLangValue('product-template', "targetmarket"), width: '10%', },
    { name: getLangValue('product-template', "publicType"), width: '10%', type: 'publicType' },
    // { name: getLangValue("attribute.structure"), width: '10%', },
    // { name: getLangValue("attribute.safety"), width: '10%', },
    // { name: getLangValue("attribute.quality1"), width: '10%', },
    // { name: getLangValue("base.operation"), width: '10%', },
])
const colors = ['#F06548', '#405189', '#0AB39C', 'green', 'pink']
const pageSizeOption = [10, 20, 30, 40, 50]
const loading = ref(false)
const { total, currentPage, pageSize, pageOption } = usetablePageNation(getDataList)
const hscode = ref('')
const keyword = ref('')
const selectedTableData = ref([])
const lastId = ref('')
const index_standard_group = ref([])
const searchInfo = ref({})
const public_type_list = ref([]);
const public_type = ref('')
// 获取公开类型
const getPublic = (type) => {
    let arr = public_type_list.value.filter(item => item.id === type)
    if (arr.length) {
        return arr[0].name
    }
    return ''
}
// 获取公开类型列表
const getProductTemplatePublicType = async () => {
    const resp = await getProductTemplatePt();
    if (resp.code == 0) {
        public_type_list.value = resp.payload
    }
}

const getDataList = async () => {
    loading.value = true
    // selectedTableData.value = []
    //获取数据
    let params = {
        page: currentPage.value - 1,
        limit: pageSize.value,
        // hscode_id: hscode.value != null && hscode.value != '' && hscode.value.length ? [...hscode.value].pop() : '',
        hscode_id: hscode.value,
        keyword: keyword.value.trim().replace('FBD', ''),
        category_id: 3, //质量
        product_template_name: type.value,
        order_by: searchInfo.value.type,
        sort_field: searchInfo.value.sortField || searchInfo.value.name,
        public_type: public_type.value,
    }
    // 产品性能
    const resp = await getDashboardPerformance_comparison(params);
    loading.value = false
    if (resp.code == 0) {
        if (resp.payload.length == 0 || resp.payload.data.length == 0) {
            showMessage('info', getLangValue('base.no_data'))
            total.value = 0
            tableInfo.value = []
            return
        }
        tableInfo.value = resp.payload.data;
        table_head.value = [
            { name: 'NO.', width: '2%', type: 'index' },
            { name: 'HS Code', width: '10%', type: 'hscode_title' },
            { name: getLangValue('product-management', "code_pid_gtin"), width: '10%', type: 'pid' },
            { name: getLangValue('product-template', "productName"), width: '10%', type: 'name', sortable: true, sortField: 'name' },
            { name: getLangValue('product-template', "targetmarket"), width: '10%', type: 'targetmarket_title' },
            { name: getLangValue('product-template', "publicType"), width: '10%', type: 'publicType' },
        ]
        // 设置表名
        if (resp.payload.index_standard_group) {
            resp.payload.index_standard_group.forEach((item, index) => {
                table_head.value.push({
                    name: item.group_name,
                    name_en: item.group_name_en,
                    width: '10%',
                    type: 'valueList',
                    index: index,
                    sortable: true,
                })
                // .push({
                //     name: item.group_name,
                //     sort: '',
                // });
            })
            index_standard_group.value = resp.payload.index_standard_group
        }
        tableInfo.value.forEach(async element => {
            // 取值 结构 安全 质量
            const index_standard_statistics = element.index_standard_statistics
            element.valueList = []
            for (const item in index_standard_statistics) {
                let value = index_standard_statistics[item].qualified_quantity ? index_standard_statistics[item].qualified_quantity : 0
                let value1 = index_standard_group.value[item].index_standard_count ? index_standard_group.value[item].index_standard_count : 0
                // console.log(value, value1);
                let res = Number(((value / value1) * 100).toFixed(2))
                element.valueList.push(res);
            }
            // 设置二维码
            if (element.pid) {
                const reps = await makeQrCode({ type: 2, id: element.id })
                if (reps) {
                    element.qrcodeImgUrl = reps
                }
            }
        });
        if(tableInfo.value.length && currentPage.value == 1 && selectedTableData.value.length ==0) {
            tableInfo.value[0].checked = true  // 默认展示第一个
            changCheckBox(tableInfo.value[0].id) // 选中事件
        }
        total.value = resp.payload.total
        setPages();
        // 如果已经选择了数据 需要回显
        if(selectedTableData.value.length) {
            for (const item in selectedTableData.value) {
                // 如果由当前数据 就需要选中
                const obj = tableInfo.value.find(table=> table.id == selectedTableData.value[item].id)
                if(obj) {
                    obj.checked = true;
                }
            }
        }
    }
}

const sort = (sortField, name) => {
    searchInfo.value.name = name
    searchInfo.value.sortField = sortField || ''
    searchInfo.value.type = searchInfo.value.type == 'asc' ? 'desc' : 'asc'
    getDataList()
}

const search = () => {
    //搜索
    // emits('search', { hscode: hscode.value, keyword: keyword.value, })
    if (!hscode.value) {
        showMessage('danger', getLangValue('dashboard.fillDataMessage1'))
        return;
    }
    currentPage.value = 1;
    selectedTableData.value = []; //置空
    getDataList();
}

const setPages = () => {
    pageOption.value = [];
    let numberOfPages = Math.ceil(total.value / pageSize.value);
    for (let index = 1; index <= numberOfPages; index++) {
        pageOption.value.push(index);
    }
}

const setCharts = () => {
    // 图表绘制
    // let xAxisData = [getLangValue('attribute.structure'), getLangValue('attribute.safety'), getLangValue('attribute.quality1')]
    let xAxisData = index_standard_group.value.map(item => i18n.global.locale == 'en' ? item.group_name_en : item.group_name)
    let option = {
        legend: { show: false },
        color: colors,
        tooltip: {
            trigger: 'axis', formatter: function (params) {
                let res = params[0].name + '<br/>'
                params.forEach(item => {
                    res += item.value ? `NO.${item.data.no + 1} `+item.seriesName + ': ' + item.value + '%<br/>' : `NO.${item.data.no + 1} `+ item.seriesName + ': -<br/>';
                })
                return res
            }
        },
        xAxis: {
            type: 'category', data: xAxisData, axisLabel: {
                show: xAxisData.length < 5 ? true : false
            }
        },
        yAxis: {},
        grid: {
            top: '3%',
            left: '0%',
            right: '0%',
            bottom: '20%',
            containLabel: true
        },
        series: selectedTableData.value.map((item, index) => {
            // item.value1 = item.valueList[0] ? item.valueList[0] : 0
            // item.value2 = item.valueList[1] ? item.valueList[1] : 0
            // item.value3 = item.valueList[2] ? item.valueList[2] : 0
            let data = []
            for (const item1 in index_standard_group.value) {
                data.push({value: item.valueList[item1], no: index});
            }
            return {
                name: item.pid,
                type: 'bar',
                data: data,
                barMaxWidth: 30,
                color: colors[index]
            }
        })
    };
    // if (xAxisData.length > 5) {
    //     option.dataZoom = [{
    //         type: 'slider',
    //         realtime: true,
    //         start: 0,
    //         end: 40,  // 初始展示40%
    //         height: 4,
    //         fillerColor: "rgba(17, 100, 210, 0.42)", // 滚动条颜色
    //         borderColor: "rgba(17, 100, 210, 0.12)",
    //         handleSize: 0, // 两边手柄尺寸
    //         showDetail: false, // 拖拽时是否展示滚动条两侧的文字
    //         bottom: 55,
    //         // zoomLock:true, // 是否只平移不缩放
    //         // moveOnMouseMove:true, //鼠标移动能触发数据窗口平移
    //         // zoomOnMouseWheel :true, //鼠标移动能触发数据窗口缩放
    //     },
    //     {
    //         type: "inside",  // 支持内部鼠标滚动平移
    //         start: 0,
    //         end: 40,
    //         zoomOnMouseWheel: false,  // 关闭滚轮缩放
    //         moveOnMouseWheel: true, // 开启滚轮平移
    //         moveOnMouseMove: true  // 鼠标移动能触发数据窗口平移 
    //     }]
    // }
    nextTick(() => {
        dashbordChart1(chartRef.value, option)
    })

}

const changCheckBox = (id) => {
    lastId.value = id
    // 复选框状态改变
    // let arr = []
    // tableInfo.value.forEach((item, index) => {
    //     if (item.checked) {
    //         item.no = index
    //         arr.push(item) 
    //     }
    // })
    const item = tableInfo.value.find(item=> item.id == id)
    if(item.checked) {
        selectedTableData.value.push(item);
    }else{
        const index = selectedTableData.value.findIndex(item=> item.id == id)
        if(index > -1) {
            selectedTableData.value.splice(index, 1)
        }
    }
    if (selectedTableData.value.length <= 5) {
        if (selectedTableData.value.length)
            setCharts();
    } else {
        //去掉最后一个id
        tableInfo.value.forEach(item => {
            if (item.id == id)
                item.checked = false
        })
        //去掉
        const index = selectedTableData.value.findIndex(item=> item.id == id)
        if(index > -1) {
            selectedTableData.value.splice(index, 1)
        }
        showMessage('info', getLangValue('dashboard.selectedLength'))
        return
    }

}

const showImageCode = (url) => {
    /**查看二维码大图 */
    activeImageSrc.value = url;
    if (activeImageSrc.value == "") {
        return;
    }
    showPreviewImg.value = true;
}

const remove = (key) => {
    // 图表移除pid
    let id = selectedTableData.value[key].id
    selectedTableData.value.splice(key, 1)
    tableInfo.value.forEach(item => {
        if (item.id == id)
            item.checked = false
    })
    changCheckBox(id)
}

// const changeTemplate = () => {
//     // 切换模版
//     hscode.value = ''
//     if (type.value) {
//         let arr = props.databaseList.filter(item => item.name === type.value)
//         hscodeList.value = arr[0].list.map(item => {
//             return {
//                 id: item.hscode.id,
//                 title: item.hscode.title,
//             }
//         })
//     } else {
//         hscodeList.value = []
//         hscode.value = ''
//     }
// }

const changeTemplate = () => {
    hscode.value = ''
    if (type.value.length) {
        console.log(type.value);
        let arr = props.databaseList.filter(item => item.value === type.value[0] && item.children.filter(item1 => item1.value === type.value[1]).length)
        if (arr.length) {
            // 获取shcode
            let arr1 = arr[0].children.filter(item => item.value === type.value[1])
            if (arr1.length) {
                hscodeList.value = arr1[0].database_template_list.map(item => {
                    return {
                        id: item.hscode?.id,
                        title: item.hscode?.title,
                        title_en: item.hscode?.title_en,
                    }
                })
            }
        }
    } else {
        hscodeList.value = []
    }
}

onMounted(() => {
    // getDataList();
    getProductTemplatePublicType();
})

watch(pageSize, () => {
    currentPage.value = 1;
    getDataList();
})

watch(currentPage, () => {
    getDataList();
})

watch(selectedTableData, (val) => {
    if (val.length) {
        document.getElementById('my-table').style.height = 'calc(100% - 350px)'
    } else {
        document.getElementById('my-table').style.height = '100%'
    }
}, { deep: true })


</script>
<template>
    <div class="qualityTable px-3 py-2 " style="height: calc(100% - 1rem) ">
        <div class="d-flex justify-content-between align-items-center">
            <div class="search d-flex align-items-center">
                <!-- <el-select @change="changeTemplate" v-model="type" filterable clearable
                    :placeholder="getLangValue('dashboard.dataBaseType')" style="width: 226px; height: 38px;">
                    <el-option v-for="item in databaseList" :key="item.value" :label="item.name" :value="item.name" />
                </el-select> -->
                <el-cascader style="width: 226px; height: 38px;" v-model="type" :options="props.databaseList"
                    :placeholder="getLangValue('dashboard.dataBaseType')"
                    :props="{ label: i18n.global.locale == 'en' ? 'label_en' : 'label', }" @change="changeTemplate" />
                <!-- <el-cascader placeholder="HS Code" style="width: 204px; height: 38px; "
                    :props="{ label: 'title', value: 'id' }" :show-all-levels="false" v-model="hscode"
                    :options="hscodeList" filterable clearable class="mx-2" /> -->
                <el-select v-model="hscode" filterable clearable class="mx-2" placeholder="HS Code"
                    style="width: 204px; height: 38px;">
                    <el-option v-for="item in hscodeList" :key="item.value"
                        :label="i18n.global.locale == 'en' ? item.title_en : item.title" :value="item.id" />
                </el-select>
                <div class="form-icon">
                    <input style="width: 236px;" clearable class="form-control form-control-icon" v-model="keyword"
                        required :placeholder="getLangValue('dashboard.input1')" />
                    <i class="ri-search-line"></i>
                </div>
                <el-select v-model="public_type" filterable clearable class="mx-2"
                    :placeholder="getLangValue('product-template.publicType')" style="width: 204px; height: 38px;">
                    <el-option v-for="item in public_type_list" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
            </div>
            <button type="button" class="btn btn-success" @click="search()" style="min-width: 93px;">
                {{ getLangValue("base.search") }}
            </button>
        </div>
        <div style="flex-direction: column; height: calc(100% - 40px);" v-loading="loading">
            <div class="my-table my-2" id="my-table">
                <!-- 表格信息 -->
                <div style="height:calc(100% - 60px - 1rem); overflow-y: auto;" class="my-scroll-bar">
                    <table class="table  table-nowrap">
                        <thead class="table-light">
                            <tr>
                                <th scope="col" v-for="(head, index) in table_head" :key="index"
                                    style="color: #2E404C; align-items: center;">
                                    <div class="d-flex align-items-center"
                                        :style="head.sortable ?
                                            { height: '36px', 'max-width': '120px', 'word-break': 'keep-all', 'white-space': 'normal' } : { height: '36px' }">
                                        {{ i18n.global.locale == 'en' ? head.name_en || head.name : head.name }}
                                        <div class="sortable mx-2 cursor-pointer" :class="searchInfo.name == head.name && searchInfo.type == 'desc' ? 'sortdesc' :
                                            searchInfo.name == head.name && searchInfo.type == 'asc' ? 'sortasc' : ''"
                                            v-if="head.sortable" style="position: relative; width: 14px; height: 10px;"
                                            @click="sort(head.sortField, head.name )">
                                        </div>
                                    </div>
                                </th>
                                <th width="10%" style="color: #2E404C;">
                                    <div class="d-flex align-items-center" style="height: 36px;">{{
                                        getLangValue("base.operation") }}</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(info, index) in tableInfo" :key="index" style="vertical-align: middle">
                                <template v-for="(head, kk) in table_head" :key="kk">
                                    <td v-if="head.type == 'index'"> {{ index + 1 }}</td>
                                    <td v-else-if="head.type == 'pid'">
                                        <img @click="showImageCode(info.qrcodeImgUrl)" class="cursor-pointer"
                                            :title="`FBD`+info.pid" :src="info['qrcodeImgUrl']"
                                            style="width: 48px;height: 48px;" />
                                    </td>
                                    <td v-else-if="head.type == 'valueList'">
                                        <span v-if="info.valueList">{{
                                            info.valueList[head.index] ? info.valueList[head.index] : 0 }}%</span>
                                    </td>
                                    <td v-else-if="head.type == 'hscode_title'">
                                        <span v-if="info.hscode">{{
                                            i18n.global.locale == 'en' ? info.hscode?.title_en : info.hscode?.title
                                            }}</span>
                                    </td>
                                    <td v-else-if="head.type == 'targetmarket_title'">
                                        <span v-if="info.destination_market">{{
                                            i18n.global.locale == 'en' ? info.destination_market?.title_en :
                                            info.destination_market?.title }}</span>
                                    </td>
                                    <td v-else-if="head.type == 'publicType'"
                                        style="width: 200px; word-break: keep-all;word-wrap: break-word; white-space: normal;">
                                        <span v-if="info.destination_market">
                                            {{ info.public_type ?
                                                getPublic(info.public_type) : '' }}</span>
                                    </td>
                                    <td v-else-if="head.type == 'name'"
                                        style="width: 250px; word-break: keep-all;word-wrap: break-word; white-space: normal;">
                                        <span v-if="info.name">{{ info.name }}</span>
                                    </td>
                                    <td v-else>
                                        {{ info[head.type] }}
                                    </td>
                                </template>
                                <td>
                                    <input @change="changCheckBox(info.id)" class="form-check-input mt-0"
                                        type="checkbox" v-model="info.checked"
                                        aria-label="Checkbox for following text input">
                                </td>
                                <!-- <td>{{ index + 1 }}</td>
                                <td>{{ info.hscode_title }}</td>
                                <td>
                                    <img @click="showImageCode(info.qrcodeImgUrl)" class="cursor-pointer"
                                        :src="info['qrcodeImgUrl']" style="width: 48px;height: 48px;" />
                                </td>
                                <td>{{ info.name }}</td>
                                <td v-if=" info.valueList">{{ info.valueList[0] }}%</td>
                                <td v-if=" info.valueList">{{ info.valueList[1] }}%</td>
                                <td v-if=" info.valueList">{{ info.valueList[2] }}%</td>
                                <td>
                                    <input @change="changCheckBox(info.id)" class="form-check-input mt-0"
                                        type="checkbox" v-model="info.checked"
                                        aria-label="Checkbox for following text input">
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- 分页 -->
                <Pagination v-if="total" v-model:page="currentPage" v-model:perPage="pageSize" :pages="pageOption"
                    :prePageOption="pageSizeOption" :tab_info_length="total" class="me-5 my-3 my-pagination">
                </Pagination>
            </div>
            <div class="charts" v-if="selectedTableData.length" style="position: relative; ">
                <div style="width: 100%; height: 100%;" ref="chartRef"></div>
                <div style="position: absolute; bottom: -15px;width: 100%; flex-wrap: wrap; min-height: 60px;"
                    class="d-flex justify-content-center">
                    <div class="mx-3 d-flex align-items-center" v-for="(item, key) in selectedTableData" :key="key"
                        style="color: #878A99;font-size: 14px;">
                        <div style="width: 14px; height: 14px;" :style="{ backgroundColor: colors[key] }"></div>
                        <span class="mx-2">No.{{key+1}} {{ item.pid }}</span>
                        <i class="ri-delete-bin-line cursor-pointer" style="color: #ED5E5E;" @click="remove(key)"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <PreviewImg v-model:showPreviewImg="showPreviewImg" :src="activeImageSrc" :myWidth="400" v-if="showPreviewImg">
    </PreviewImg>
</template>
<style scoped lang="scss">
.qualityTable {
    .search {
        flex: 1;
        height: 38px;

        :deep(.el-input--suffix) {
            // width: 110px;
            height: 100%;
        }

        :deep(.el-select__wrapper) {
            // background-color: #4a5056;
            height: 100%;
        }

        :deep(.el-select__placeholder.is-transparent) {
            color: #889AA5 !important;
        }

        :deep(.el-select__selected-item) {
            // color: white;
        }

        :deep(.el-input__wrapper) {
            // background-color: #4a5056;
        }

        :deep(.el-input__inner) {
            // color: white;
        }

        .form-icon {
            display: inline-block;

            i {
                // color: white
            }
        }

        .form-control {
            // background-color: #4a5056;
            // color: white;
            display: inline-block;
        }
    }

    .my-table {
        flex: 1; //way-2
        height: 100%; //way-2

        // max-height: 500px; // way-1
        table {
            color: #212529;
        }

        .my-pagination {
            color: #212529;

            :deep(.page_total) {
                color: #212529 !important;
            }
        }
    }

    .charts {
        height: 350px;
    }

    .sortActive {
        i {
            color: black !important;
        }

    }

    :deep(.el-select__placeholder.is-transparent) {
        font-size: 0.8125rem;
        color: #878a99 !important;
    }

    :deep(.el-select__selected-item.el-select__placeholder) {
        font-size: 0.8125rem;
        color: #212529;
    }

    :deep(.el-cascader .el-input__inner) {
        font-size: 0.8125rem;
        color: #212529;
    }

    :deep(.el-cascader .el-input__inner::placeholder) {
        color: #878a99;
    }

    :deep(.el-cascader .el-input__inner::-webkit-input-placeholder) {
        color: #878a99;
    }

    :deep(.el-cascader .el-input__inner::-moz-placeholder) {
        color: #878a99;
    }

    :deep(.el-cascader .el-input__inner::-moz-placeholder) {
        color: #878a99;
    }

    :deep(.el-cascader .el-input__inner::-ms-input-placeholder) {
        color: #878a99;
    }

    .sortable {
        &::after {
            content: "\f035d";
            position: absolute;
            right: .5rem;
            top: 0px;
            font-size: .8rem;
            font-family: "Material Design Icons";
            color: #bcbdbe;
        }

        &::before {
            content: "\f0360";
            position: absolute;
            right: .5rem;
            top: -8px;
            font-size: .8rem;
            font-family: "Material Design Icons";
            color: #bcbdbe;
        }
    }

    .sortdesc {
        &::after {
            color: black;
        }
    }

    .sortasc {
        &::before {
            color: black;
        }
    }
}
</style>